export const PIPELINE_STAGES = {
    NEW: {
      id: 'NEW',
      title: 'New',
      color: 'bg-gray-50',
      headerColor: 'bg-gray-100'
    },
    OFFER_SUBMITTED: {
      id: 'OFFER_SUBMITTED',
      title: 'Offer Submitted',
      color: 'bg-blue-50',
      headerColor: 'bg-blue-100'
    },
    NEGOTIATION: {
      id: 'NEGOTIATION',
      title: 'Negotiation',
      color: 'bg-yellow-50',
      headerColor: 'bg-yellow-100'
    },
    // DECISION_PENDING: {
    //   id: 'DECISION_PENDING',
    //   title: 'Decision Pending',
    //   color: 'bg-purple-50',
    //   headerColor: 'bg-purple-100'
    // },   
    DEAL_ON_HOLD: {
      id: 'DEAL_ON_HOLD',
      title: 'Deal on Hold',
      color: 'bg-orange-50',
      headerColor: 'bg-orange-100'
    },
    DEAL_WON: {
      id: 'DEAL_WON',
      title: 'Deal Won',
      color: 'bg-green-50',
      headerColor: 'bg-green-100'
    },
    DEAL_LOST: {
      id: 'DEAL_LOST',
      title: 'Deal Lost',
      color: 'bg-red-50',
      headerColor: 'bg-red-100'
    },
  };

export const getPipelineStageOptions = () => {
  return Object.values(PIPELINE_STAGES);
};

export const getStageById = (stageId) => {
  return PIPELINE_STAGES[stageId] || null;
};